const positions1 = [
  { top: '39.87vw', left: '15.05vw' },
  { top: '28.56vw', left: '15.81vw' },
  { top: '19.55vw', left: '22.53vw' },
  { top: '26.35vw', left: '40.63vw' },
  { top: '31.28vw', left: '28.56vw' },
  { top: '14.71vw', left: '35.36vw' },
  { top: '18.02vw', left: '48.11vw' },
  { top: '37.57vw', left: '45.14vw' },
  { top: '28.56vw', left: '54.91vw' },
  { top: '42.16vw', left: '57.21vw' },
];

const positions3 = [
  { top: '29vw', left: '15.7vw' },
  { top: '42vw', left: '17.2vw' },
  { top: '18vw', left: '22vw' },
  { top: '26vw', left: '37.5vw' },
  { top: '32vw', left: '26.8vw' },
  { top: '13.5vw', left: '35vw' },
  { top: '17.5vw', left: '48vw' },
  { top: '35vw', left: '44vw' },
  { top: '28vw', left: '52vw' },
  { top: '40vw', left: '55.8vw' },
];

const positions4 = [
  { top: '30vw', left: '15.7vw' },
  { top: '45vw', left: '20vw' },
  { top: '17vw', left: '21vw' },
  { top: '45vw', left: '35vw' },
  { top: '31vw', left: '29.5vw' },
  { top: '13vw', left: '35vw' },
  { top: '19vw', left: '49vw' },
  { top: '31.5vw', left: '45vw' },
  { top: '25vw', left: '58.5vw' },
  { top: '43vw', left: '54vw' },
];
const positions5 = [
  { top: '28vw', left: '15vw' },
  { top: '40vw', left: '16vw' },
  { top: '17vw', left: '22vw' },
  { top: '39vw', left: '41vw' },
  { top: '30vw', left: '29.5vw' },
  { top: '13vw', left: '35vw' },
  { top: '16.5vw', left: '49vw' },
  { top: '25vw', left: '40.5vw' },
  { top: '27vw', left: '55vw' },
  { top: '40vw', left: '57vw' },
];
const positions6 = [
  { top: '23vw', left: '17vw' },
  { top: '35vw', left: '15vw' },
  { top: '14vw', left: '24vw' },
  { top: '33vw', left: '46vw' },
  { top: '27vw', left: '29.5vw' },
  { top: '8.5vw', left: '35.5vw' },
  { top: '12vw', left: '52vw' },
  { top: '22.2vw', left: '40vw' },
  { top: '24vw', left: '53.5vw' },
  { top: '36vw', left: '57vw' },
];
const positions7 = [
  { top: '28vw', left: '15vw' },
  { top: '15vw', left: '19.5vw' },
  { top: '29vw', left: '26vw' },
  { top: '21vw', left: '38vw' },
  { top: '38vw', left: '17vw' },
  { top: '7vw', left: '35vw' },
  { top: '15vw', left: '49vw' },
  { top: '38vw', left: '43vw' },
  { top: '27vw', left: '56vw' },
  { top: '42vw', left: '56vw' },
];
const positions8 = [
  { top: '39vw', left: '15vw' },
  { top: '28vw', left: '16vw' },
  { top: '18vw', left: '24vw' },
  { top: '26vw', left: '40vw' },
  { top: '30vw', left: '29vw' },
  { top: '13vw', left: '35vw' },
  { top: '16vw', left: '48vw' },
  { top: '36.5vw', left: '45vw' },
  { top: '27vw', left: '54vw' },
  { top: '39.5vw', left: '57vw' },
];
const positions9 = [
  { top: '30vw', left: '12vw' },
  { top: '13vw', left: '19vw' },
  { top: '23vw', left: '24vw' },
  { top: '23vw', left: '38vw' },
  { top: '35vw', left: '29vw' },
  { top: '9vw', left: '32vw' },
  { top: '11vw', left: '46vw' },
  { top: '37vw', left: '44vw' },
  { top: '21vw', left: '54vw' },
  { top: '30vw', left: '57vw' },
];
const positions10 = [
  { top: '22vw', left: '13vw' },
  { top: '14vw', left: '22vw' },
  { top: '27vw', left: '26vw' },
  { top: '20vw', left: '38vw' },
  { top: '33vw', left: '17vw' },
  { top: '9vw', left: '35vw' },
  { top: '13vw', left: '47vw' },
  { top: '33vw', left: '40vw' },
  { top: '23vw', left: '52vw' },
  { top: '35vw', left: '53vw' },
];

export const positions = [
  positions1,
  positions1,
  positions3,
  positions4,
  positions5,
  positions6,
  positions7,
  positions8,
  positions9,
  positions10,
];
